// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__3ZmH2","main":"Slider_main__naqkC","breadcrumbs":"Slider_breadcrumbs__KytIE","linkWrapper":"Slider_linkWrapper__QfHET"};